export mascote from "./mascote.png";



// WEBPACK FOOTER //
// ./src/components/app/forbidden/images/index.js